import axios from "axios";

/**
 * Fetches the current admin's unread-summary for the Support nav badge.
 * Scoped server-side to tickets the admin is the assignee of OR has
 * commented on at least once. See TicketReadStateService.
 *
 * Response envelope: { success, code, message, data: { total_unread, tickets } }
 *   tickets[i]: { ticket_id, ticket_number, title, unread_count, last_comment_at }
 */
export default function getUnreadSummary() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/notifications/unread-summary")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
